<common-internal-header [navigationItems]="navigationItems" [routerLinkActiveOptions]="{ exact: true }" [showPhoneIcon]="true"></common-internal-header>
<main role="main">
  <router-outlet></router-outlet>
  <!-- not needed now -->
  <!-- <common-pwa-install-banner></common-pwa-install-banner> -->
</main>
